import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';

import { Types, Creators } from 'store/ducks/interest/update';
import { callApi } from 'store/sagas/auth';
import { push } from 'connected-react-router';

import Notifications from 'react-notification-system-redux';

function* getInterestUpdate({ payload }) {
  try {
    const { id, name, status } = payload;
    const request = call(api.put, `/v1/admin/users/interests/${id}`, {
      name,
      status,
    });
    const response = yield call(callApi, request);
    yield put(Creators.getInterestUpdateSuccess());
    yield put(Notifications.success({ title: 'Edição concluida com sucesso' }));
  } catch (err) {
    yield put(Creators.getInterestUpdateFailure('Erro ao buscar na API'));
    const { id } = payload;
    yield put(push(`/interests/update/${id}`));
  }
}

// Individual exports for testing
export default function* productListSaga() {
  yield all([takeLatest(Types.GET_UPDATE_REQUEST, getInterestUpdate)]);
}
